import { Action, SignupErrorCode, SignupOnboardFieldErrors } from '../types';

export interface State {
  error: SignupErrorCode | null;
  fieldErrors: SignupOnboardFieldErrors;
  isLoading: boolean;
  redirectTo: string | null;
  autoSubmit: boolean;
}

export const defaultState: State = {
  error: null,
  fieldErrors: {},
  isLoading: false,
  redirectTo: null,
  autoSubmit: false,
};

const signupOnboard = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'SIGNUP_ONBOARD_RESET':
      return defaultState;
    case 'SIGNUP_ONBOARD_REQUEST':
      return {
        ...state,
        error: null,
        fieldErrors: {},
        isLoading: true,
      };
    case 'SIGNUP_ONBOARD_REQUEST_SUCCESS':
      return {
        ...state,
        isLoading: false,
        fieldErrors: {},
        redirectTo: action.redirectTo,
      };
    case 'SIGNUP_ONBOARD_REQUEST_FAILED':
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case 'SIGNUP_ONBOARD_SHOW_FIELD_ERRORS':
      return {
        ...state,
        fieldErrors: action.errors,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default signupOnboard;
